
export enum EnumTpCalculoModificador {
    Soma = 0,
    Rateia = 1,
    Maior = 2,
}